export const login = {
  email_label: "Adresse email",
  password_label: "Mot de passe",
  remember_me: "Se souvenir de moi",
  forgot_password: "Mot de passe oublié",
  btn_signin: "Se connecter",
  unable_to_login: "Vous n’arrivez pas à vous connecter ?",
  resend_confirmation_email: "Recevoir l’email de confirmation",
  no_account: "Vous n’avez pas de compte ?",
  btn_signup: "Inscrivez-vous gratuitement",
  title: "Connexion",
  email_invalid: "Email invalide",
  email_required: "Email requis",
  password_min: "Minimum 6 caractères",
  password_required: "Mot de passe requis",
  invalid_credentials: "Email ou mot de passe incorrect",
  signup: "Inscrivez-vous gratuiement",
  dont_have_account: "Vous n’avez pas de compte ?",

  confirmEmail: "Confirmez votre adresse mail",
  enterCodeInstruction: "Veuillez entrer le code envoyé sur votre adresse mail",
  resendEmail: "Renvoyer le mail",
  contactSupport: "Si vous n’avez pas reçu d’email, contactez le support",
  confirm: "Confirmer",
  reset_password: "Réinitialiser le mot de passe",
  email_placeholder: "Adresse email",
  verifying: "Vérification en cours...",
  send: "Envoyé",
};
